import { ACCOUNTS_PATH } from '../accounts/accountPaths'

export const OVERVIEW_PATH = '/overview'

/**
 * `/accounts/connect`. App.tsx owns `ACCOUNT_CONNECT_PATH` but imports this
 * module's screen, so importing it back would be a cycle; derived from the
 * accounts module's own path instead of retyped.
 */
export const CONNECT_ACCOUNT_PATH = `${ACCOUNTS_PATH}/connect`
